import { SubscriptionStatus } from "../../../../OrderFlow/utils/orderFlowUtils";
import { useCompany } from "../../../../Shared/components/CompanyProvider/CompanyProvider";
import { ORDER_STATUS } from "../../../../Shared/utils/constants";
import { tokenReplace } from "../../../../Shared/utils/tokenReplacement";
import { OrderDetailsText } from "../utils/OrderDetailsAccordion-types";
import { buildForWeekStartingOn, buildMappedMeals, getOrderTotal, getOrderType, getOrderTypeDetails, } from "../utils/orderDetailsUtils";
export const useOrderDetailsAccordion = (currentOrder, companyConfig, skippedDays) => {
    var _a, _b, _c, _d, _e;
    const { culture, tokenMap } = useCompany();
    const orderForWeekStartingOn = buildForWeekStartingOn(currentOrder, companyConfig === null || companyConfig === void 0 ? void 0 : companyConfig.startSunday);
    const companyText = (companyConfig === null || companyConfig === void 0 ? void 0 : companyConfig.companyText) && ((_a = companyConfig === null || companyConfig === void 0 ? void 0 : companyConfig.companyText) === null || _a === void 0 ? void 0 : _a.length) ? companyConfig === null || companyConfig === void 0 ? void 0 : companyConfig.companyText : [];
    let noMealsSelectedText = (_c = (_b = companyText.find((text) => text.Title == "NoMealsSelectedText")) === null || _b === void 0 ? void 0 : _b.Text) !== null && _c !== void 0 ? _c : OrderDetailsText.MEALS_NOT_SELECTED;
    noMealsSelectedText = tokenReplace(noMealsSelectedText, true, tokenMap);
    const orderTotal = getOrderTotal(companyConfig, currentOrder, culture);
    const orderIsSkipped = ((_d = currentOrder.order.OrderMealDays) === null || _d === void 0 ? void 0 : _d.length) === 0 && ((_e = currentOrder.orderInfo.product_items) === null || _e === void 0 ? void 0 : _e.length) === 0;
    const mappedMeals = buildMappedMeals(currentOrder, skippedDays, noMealsSelectedText);
    const orderTypeInfo = getOrderType(currentOrder);
    const orderTypeDetails = getOrderTypeDetails(currentOrder);
    const showSubscriptionLinkId = currentOrder.order.OrderStatus === ORDER_STATUS.FUTURE ||
        currentOrder.order.SubscriptionStatus !== SubscriptionStatus.None;
    return {
        orderForWeekStartingOn,
        orderTotal,
        orderIsSkipped,
        mappedMeals,
        orderTypeInfo,
        orderTypeDetails,
        showSubscriptionLinkId,
    };
};
